import React from 'react';
import PropTypes from 'prop-types';
import { Grow } from '@material-ui/core';
import './RaisedContainer.css';

const RaisedContainer = React.forwardRef(({ animated, ...props }, ref) => {
  return (
    animated
      ? <Grow in ref={ref}>
        <div {...props} className='raised-container'>
          { props.children }
        </div>
      </Grow>
      : <div {...props} className='raised-container' ref={ref}>
        { props.children }
      </div>
  );
});

RaisedContainer.propTypes = {
  animated: PropTypes.bool
};

RaisedContainer.defaultProps = {
  animated: true
};

export default RaisedContainer;
